import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { TownsState } from './types';

export const getTownsState = (state: StoreState): TownsState => state.towns;

export const getTowns = createSelector(getTownsState, state => state.towns);
